import classnames from 'classnames';
import React, { ReactNode } from 'react';

type NavBarProps = {
  children?: ReactNode;
  className?: string;
  isSticky?: boolean;
};

/**
 * The bar the Gleamer headers sit in.
 *
 * OHIF 3.11 deleted `@ohif/ui`'s `NavBar` and ui-next has no equivalent — its
 * `Header` is a complete, props-driven header rather than a shell, and the two
 * Gleamer headers (viewer + worklist) put entirely different content inside.
 * So this is ours now, not a vendored copy: same markup as the component it
 * replaces, minus the PropTypes.
 */
export function NavBar({ children, className, isSticky }: NavBarProps) {
  return (
    <div
      className={classnames(
        // Match the deleted @ohif/ui NavBar exactly: `flex flex-row items-center`
        // (the callers' `justify-between` needs it) and `border-b-4`. The 52px
        // height came from the inline style below — dropping it collapsed the
        // header to content height.
        'z-20 flex flex-row items-center px-1',
        isSticky ? 'sticky top-0' : 'relative',
        className
      )}
      style={{ paddingTop: '4px', paddingBottom: '4px', minHeight: '52px' }}
    >
      {children}
    </div>
  );
}

export default NavBar;
